import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

import { Store } from '@ngrx/store';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  CountryCRUDStatus,
  PricingCountryActions,
  PricingCountryCreateUpdatePayload,
  PricingCountryService,
  UntilDestroy,
  selectCountryCRUDStatus,
  selectLoadedPricingCountryData,
  untilDestroyed,
} from '@shared';
import { Observable, combineLatest } from 'rxjs';
import { ConstantCountryOption, PricingCountry } from 'thkee-common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormPriceCountryComponent } from '../../../../@shared/components/forms/price-country/price-country.component';
import { AsyncPipe } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'app-view',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.scss'],
    imports: [RouterLink, AngularSvgIconModule, FormPriceCountryComponent, AsyncPipe]
})
export class PriceCountryViewComponent implements OnInit {
  private store = inject(Store);
  private route = inject(ActivatedRoute);
  private pricingCountryService = inject(PricingCountryService);
  private router = inject(Router);

  id = '';
  priceCountry$: Observable<PricingCountry> = this.store.select(selectLoadedPricingCountryData);
  status$: Observable<CountryCRUDStatus> = this.store.select(selectCountryCRUDStatus);
  countriesOptions$: Observable<ConstantCountryOption[]> = new Observable();
  priceCountryDataDefault: PricingCountry = {
    id: '',
    name: '',
    two_letter_iso_code: '',
    three_letter_iso_code: '',
    numeric_iso_code: '',
    subject_to_vat: false,
    allow_billing: false,
    currency_code: '',
    sort_number: 0,
  };
  hasData = false;
  formData: any = {};
  pringCountryUpdatePayload!: PricingCountryCreateUpdatePayload;

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id') || '';

    this.store.dispatch(PricingCountryActions.getPricingCountry({ id: this.id }));
    this.countriesOptions$ = this.pricingCountryService.getConstantCountries();

    combineLatest([this.countriesOptions$, this.priceCountry$, this.status$])
      .pipe(untilDestroyed(this))
      .subscribe(([countries, country, status]) => {
        this.formData = country;
        this.hasData = true;

        // Status
        if (status === CountryCRUDStatus.Success) {
          console.log('Country saved successfully', this.formData);
          this.router.navigate(['/price-management/countries']); // Navigate to the countries list
        }
      });
  }

  onInit(fields: FormlyFieldConfig[]) {
    this.disableFiels(fields);
  }

  disableFiels(objects: FormlyFieldConfig[]): FormlyFieldConfig[] {
    return objects.map((obj) => {
      if (obj.key && obj.type) {
        obj.props = {
          ...obj.props,
          disabled: true,
        };
      }
      if (obj.fieldGroup && obj.fieldGroup.length > 0) {
        obj.fieldGroup = this.disableFiels(obj.fieldGroup);
      }
      return obj;
    });
  }

  onSubmit(event: any) {
    let values = event?.values;
    this.pringCountryUpdatePayload = values;
    this.store.dispatch(PricingCountryActions.updatePricingCountry(this.pringCountryUpdatePayload));
  }
}
